// extracted by mini-css-extract-plugin
export default {"container":"TwoColumnGrid_container__M0TPL"};